// 页面类型
export const pageType = {
  homePage: 'homePage', //首页
  smartOrderPage: 'smartOrderPage', //智能工单提交页
  faqListPage: 'faqListPage', // faq列表页
  searchPage: 'searchPage', // 搜索页
  faqDetailPage: 'faqDetailPage', // faq详情页
  orderListPage: 'orderListPage', // 工单列表页
  orderDetailPage: 'orderDetailPage', // 工单详情页
  orderCreatePage: 'orderCreatePage', // 创建新工单页
  accountDeletePage: 'accountDeletePage' // 账号删除页
};

// 弹窗类型
export const popupType = {
  emailSubscribePopup: 'emailSubscribePopup', // 邮件订阅弹窗
  noticePopup: 'noticePopup' // 通知弹窗
};

// 按钮触发位置
export const locationType = {
  ...pageType,
  ...popupType
};

/**
  页面展示
  key: 页面类型key
  */
export const viewPage = key => {
  window?.officialSupportDataLayer?.push({
    eventName: 'view_page',
    eventType: pageType[key] || key || ''
  });
};

/**
  弹窗展示
  popupType: 描述弹窗类型
  */
export const showPopup = key => {
  window?.officialSupportDataLayer?.push({
    eventName: 'show_popup',
    eventType: popupType[key] || key || ''
  });
};

/**
  按钮点击
  btnName: 按钮名称
  reason: 按钮所属模块
  */
export const clickButton = ({ btnName, locationKey, otherParams }) => {
  window?.officialSupportDataLayer?.push({
    eventName: 'click_button',
    eventType: btnName || '',
    eventReason: locationType[locationKey] || locationKey || '',
    eventValue: otherParams
  });
};

/**
 * 智能工单增强事件（旧表单 order_version=1；V2 为 2）
 * - view_page + eventValue.exposeStage=formReady：模板加载成功曝光
 * - load_form_fail：拉模板失败
 * - submit_order_fail：校验失败 / 提交接口失败（failType: validate|api）
 */
export const SMART_ORDER_FAIL_TYPE = {
  validate: 'validate',
  api: 'api',
  load: 'load'
};
/** @deprecated 使用 SMART_ORDER_FAIL_TYPE */
export const SMART_ORDER_V2_FAIL_TYPE = SMART_ORDER_FAIL_TYPE;

/**
 * 灰度结算来源（看板 eventReason / eventValue.source）
 * - api：接口成功且带回版本号
 * - api_empty：接口成功但无 support_center_version（兜底）
 * - api_fail：接口业务失败 result≠1（兜底）
 * - network_fail：请求异常 / 网络错误（兜底）
 * - url_force：URL version=2 强制 V2
 * - cache / skipped_worktemp：预留
 */
export const SUPPORT_CENTER_VERSION_SOURCE = {
  api: 'api',
  apiEmpty: 'api_empty',
  apiFail: 'api_fail',
  networkFail: 'network_fail',
  urlForce: 'url_force',
  cache: 'cache',
  /** @deprecated 请用 api_empty / api_fail / network_fail */
  failFallback: 'fail_fallback',
  skippedWorktemp: 'skipped_worktemp'
};

const truncateErrmsg = (errmsg, max = 200) => {
  const text = String(errmsg || '').trim();
  if (!text) return '';
  return text.length > max ? `${text.slice(0, max)}…` : text;
};

/**
 * 客服中心灰度结算（getSupportCenterVersion）— 看板监控
 * - eventName: support_center_version
 * - eventType: 最终页面版本 1|2（看 V1/V2 占比与趋势）
 * - eventReason: 结算来源 api|api_empty|api_fail|network_fail|url_force
 * - eventValue:
 *   - apiVersion / resolvedVersion
 *   - resolvePath: URL 强制前的原始路径（便于对比 url_force 掩盖的接口结果）
 *   - isFallback / isUrlForce: 0|1
 *   - result / errmsg: 业务码与错误文案分布
 */
export const trackSupportCenterVersion = ({
  apiVersion,
  resolvedVersion,
  source,
  resolvePath,
  isFallback,
  isUrlForce,
  isLogin,
  gameId,
  result,
  errmsg
} = {}) => {
  const resolved = resolvedVersion == null ? '' : String(resolvedVersion);
  const src = source || '';
  const path = resolvePath || src;
  const fallback =
    typeof isFallback === 'boolean'
      ? isFallback
      : src !== SUPPORT_CENTER_VERSION_SOURCE.api &&
        src !== SUPPORT_CENTER_VERSION_SOURCE.urlForce;
  const urlForce = !!isUrlForce;
  const point = {
    eventName: 'support_center_version',
    eventType: resolved,
    eventReason: src,
    eventValue: {
      apiVersion: apiVersion == null || apiVersion === '' ? '' : String(apiVersion),
      resolvedVersion: resolved,
      source: src,
      resolvePath: path,
      isFallback: fallback ? 1 : 0,
      isUrlForce: urlForce ? 1 : 0,
      isLogin: isLogin ? 1 : 0,
      gameId: gameId || '',
      result: result == null || result === '' ? '' : String(result),
      errmsg: truncateErrmsg(errmsg)
    }
  };
  window.__lastSupportCenterVersionTrack = point;
  window?.officialSupportDataLayer?.push(point);
};

/**
  各模块停留时长
  locationKey: 页面
  duration: 展示总时长
  */
export const sendStayTime = ({ locationKey, duration }) => {
  window?.officialSupportDataLayer?.push({
    eventName: 'stay_time',
    eventType: locationType[locationKey] || locationKey || '',
    eventValue: {
      duration
    }
  });
};
